import { BaseLayout } from '@efast_public/fjd-component-library';
import { RoutePaths } from '../pages/AppRoutes';
import { BehHeader } from './Header/Header';
import { BehFooter } from './Footer/BehFooter';
import { MainNavigation } from './MainNavigation/MainNavigation';
import { SchreibtischTabbar } from './SchreibtischTabbar/SchreibtischTabbar';
import { useLocation } from 'react-router-dom';
import { BehLayoutSkeleton } from './BehLayoutSkeleton';
import { useProfile } from '../shared/hooks/AuthContext';

export function BehLayout({
  children
}: {
  readonly children?: React.ReactNode;
}) {
  useLocation();
  const isOnConfigAssistent = document.location.pathname.includes(
    RoutePaths.CONFIGASSISTANT
  );
  const { isLoading: isProfileLoading } = useProfile();

  if (isProfileLoading) {
    return <BehLayoutSkeleton />;
  }

  return (
    <BaseLayout
      footer={<BehFooter />}
      header={<BehHeader />}
      navigation={
        isOnConfigAssistent ? undefined : (
          <>
            <MainNavigation />
            <SchreibtischTabbar />
          </>
        )
      }
      mainContentWidth="wide"
      mainContent={
        <div
          style={{
            minHeight: 'calc(100vh - 86px - 54px - 86px)',
            padding: '1rem 3rem'
          }}
        >
          {children}
        </div>
      }
    />
  );
}
